import posthog from 'posthog-js';
import type { AnyRouter } from '@tanstack/react-router';

export function subscribePostHogPageview(router: AnyRouter): () => void {
  return router.subscribe('onResolved', ({ toLocation }) => {
    posthog.capture('$pageview', { $current_url: toLocation.href });
  });
}
